export default function ListingAutomation() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ③ 出品の自動化
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <span className="text-2xl font-bold text-blue-600">1</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">既存カタログ出品（相乗り）</h3>
            </div>
            <div className="bg-blue-50 rounded-xl p-6">
              <p className="text-gray-800 font-medium mb-2">
                → CSVで100件一括登録
              </p>
              <p className="text-sm text-gray-600">
                既存の商品ページに出品する場合
              </p>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl p-8 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                <span className="text-2xl font-bold text-primary">2</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900">新規商品登録</h3>
            </div>
            <div className="bg-primary/5 rounded-xl p-6">
              <p className="text-gray-800 font-medium mb-2">
                → 商品マスタCSV生成
              </p>
              <p className="text-sm text-gray-600">
                新しい商品ページを作成する場合
              </p>
            </div>
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-8 shadow-lg mb-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-8">自動生成項目</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { icon: 'ri-text', label: 'タイトル' },
              { icon: 'ri-price-tag-3-line', label: 'ブランド' },
              { icon: 'ri-folder-line', label: 'カテゴリ' },
              { icon: 'ri-layout-grid-line', label: 'バリエーション' },
              { icon: 'ri-file-text-line', label: '説明文（AI）' },
              { icon: 'ri-key-line', label: 'キーワード' }
            ].map((item, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 text-center hover:bg-primary/5 transition-colors">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className={`${item.icon} text-2xl text-primary`}></i>
                </div>
                <div className="font-bold text-gray-900">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="bg-gradient-to-r from-primary to-primary-dark text-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold mb-6">自動化フロー</h3>
          <div className="flex flex-col md:flex-row items-center justify-center gap-6">
            <div className="bg-white/20 rounded-xl px-6 py-4 font-bold text-lg whitespace-nowrap">
              スプレッドシート
            </div>
            <i className="ri-arrow-right-line text-3xl"></i>
            <div className="bg-white/20 rounded-xl px-6 py-4 font-bold text-lg whitespace-nowrap">
              CSV
            </div>
            <i className="ri-arrow-right-line text-3xl"></i>
            <div className="bg-white/20 rounded-xl px-6 py-4 font-bold text-lg whitespace-nowrap">
              アップロード
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
